import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/translation/en.json';
// import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // .use(HttpApi) // Load translations using Http backend
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources: {
      en: {
        translation: en, // English translations
      },
      // fr: {
      //   translation: fr, // French translations
      // },
    },
    lng: 'en', // Default language
    fallbackLng: 'en', // Fallback language if the detected language is not available
    interpolation: {
      escapeValue: false, // React already does escaping
    },
  });

export default i18n;
